import CurrencyFormatter from "currency-formatter"

export const useCurrency = () => {
  const formatCurrency = (amount, code, precision) => CurrencyFormatter.format(amount, { code, precision })
  return { formatCurrency }
}
